export default "__VITE_ASSET__009726d8__"